import React from 'react';

import HttpMonitorHeader from 'features/http/ui/HttpMonitor/HttpMonitorHeader/HttpMonitorHeader';
import useHttpMonitorDetailsScreen from 'features/http/model/useHttpMonitorDetailsScreen';

import HttpMonitorAvgResponseTimeChart from './HttpMonitorAvgResponseTimeChart/HttpMonitorAvgResponseTimeChart';
import HttpMonitorDetails from './HttpMonitorDetails';
import HttpMonitorIncidents from './HttpMonitorIncidents';
import HttpMonitorLogs from './HttpMonitorLogs';
import HttpMonitorTabs from './HttpMonitorTabs/HttpMonitorTabs';

import styles from './HttpMonitorDetails.module.scss';

const HttpMonitorDetailsScreen: React.FC = () => {
    const {monitor, activeTab, setActiveTab, showHeader, chartHeight} = useHttpMonitorDetailsScreen();

    if (!monitor) return null;

    return (
        <>
            {
                showHeader &&
                <div className={styles.containerHeader}>
                    <HttpMonitorHeader item={monitor} />
                </div>
            }
            <HttpMonitorDetails item={monitor}/>
            <HttpMonitorAvgResponseTimeChart
                item={monitor}
                uuid={monitor.uuid}
                height={chartHeight}
            />
            <HttpMonitorTabs activeTab={activeTab} onTabChange={setActiveTab} />
            {activeTab === 'incidents' && <HttpMonitorIncidents key="incidents" monitor={monitor} />}
            {activeTab === 'logs' && <HttpMonitorLogs key="logs" monitor={monitor} />}
        </>
    );
};

export default HttpMonitorDetailsScreen;
